export enum WaterwayType{
    UNKNOWN,
    LAKE,
    RIVER,
    COASTAL
}